import styled from "styled-components";
import { ColorV2 } from "config/colors";
import { TypographyV2 } from "config/font";
import { media } from "components/designV2/breakpoints";
import { MonthGridRow } from "../../common/scheduleRow/scheduleRow.styled";

export const MonthHeaderCard = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 16px 24px 0;
  border-radius: 24px 24px 0 0;
  background: ${ColorV2.White};
  width: 100%;
  max-width: 100%;
  margin-top: 16px;
  transition: border-radius 220ms ease;

  &[data-stuck="true"] {
    border-radius: 24px;
  }
`;

export const MonthView = styled.div`
  display: flex;
  flex-direction: column;
  padding-bottom: 24px;
`;

export const MonthScrollContainer = styled.div`
  overflow-x: auto;
  width: 100%;
`;

export const MonthHeader = styled.div`
  display: flex;
  justify-content: center;
`;

export const StickyDatesSentinel = styled.div`
  height: 1px;
  margin-bottom: -1px;
`;

export const StickyDatesBar = styled.div`
  position: sticky;
  top: 16px;
  z-index: 3;
  margin-top: -4px;
  background: ${ColorV2.White};
  border-radius: 0 0 24px 24px;
  padding: 0 16px 12px;
  box-shadow: 0 0 0 rgba(15, 23, 42, 0);
  transition:
    box-shadow 220ms ease,
    border-radius 220ms ease;

  &[data-stuck="true"] {
    border-radius: 24px;
    box-shadow: 0 8px 24px rgba(15, 23, 42, 0.08);
  }

  ${MonthScrollContainer} {
    scrollbar-width: none;
    -ms-overflow-style: none;
    &::-webkit-scrollbar {
      display: none;
    }
  }
`;

export const MonthRow = styled(MonthGridRow)`
  width: max-content;
  grid-auto-rows: 21px 26px;
  row-gap: 4px;

  ${media.desktopMedium} {
    width: 100%;
  }
`;

export const MonthRowSpacer = styled.div`
  grid-row: 1 / span 2;
  height: 51px;
`;

export const WeekGroup = styled.div<{ $dayCount: number }>`
  position: relative;
  grid-column: span ${(props) => props.$dayCount};
  grid-row: 1;
  display: flex;
  justify-content: center;

  &::before {
    content: "";
    position: absolute;
    top: 0;
    bottom: -30px;
    left: -6px;
    width: 1px;
    background: ${ColorV2.Blue6};
  }
`;

export const DaySlot = styled.div<{ $isToday: boolean }>`
  grid-row: 2;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  height: 26px;
  margin-right: 8px;
  background: ${(props) => (props.$isToday ? ColorV2.Blue6 : "transparent")};
  cursor: pointer;
  transition:
    background-color 160ms ease,
    box-shadow 160ms ease,
    transform 160ms ease;

  &:hover {
    background: ${ColorV2.Blue7};
    box-shadow: 0 2px 6px ${ColorV2.Blue6};
    transform: translateY(-1px);
  }

  &:focus-visible {
    outline: 2px solid ${ColorV2.Blue2};
    outline-offset: 2px;
  }
`;

export const WeekNumber = styled.span`
  ${TypographyV2.s1};
  color: ${ColorV2.Blue5};
  white-space: nowrap;
`;

export const DayNumber = styled.span<{
  $isWeekend: boolean;
  $isToday: boolean;
}>`
  ${TypographyV2.s1};
  color: ${(props) =>
    props.$isToday
      ? ColorV2.Blue1
      : props.$isWeekend
        ? ColorV2.NegativeRed
        : ColorV2.Blue4};
`;
